module.exports = __webpack_public_path__ + "img/1F643.c1ff3590.svg";